module.exports = __webpack_public_path__ + "img/category-casino-hover.3542faa9.png";